import React from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { Button, Dialog, Input, RadioButton, Uploader } from '@app/components';

import {
  ModalContainer,
  ChecklistText,
  ChecklistInfoBox,
  Footer,
  ChecklistButtonContainer,
  CancelButton,
  ModalInput,
  SavingIndicator,
  ChecklistPrimaryText,
  ChecklistInfoCard,
  RadioItem,
  ModalInfocard,
} from '@app/modules/transaction-details/transactions-details-components';

import { ActivityLogInfo } from '@app/types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { primaryColor } from '@app/styles';
import TransactionlogoUrl from '@app/assets/images/Transactionblack.svg';
import { useUpdateChecklistMutation } from '@app/graphql';

type WaterReadingProps = {
  finalReadingAvailNow: string;
  FinalReadingRequested: string;
  dateForFinalReading?: string;
  image?: string;
  fileName?: string;
  userType?: string;
};

type Props = {
  onModalClose?: any;
  userFirebaseId: string;
  waterReadingData: WaterReadingProps;
  loadChecklistData: (checklistData: any, pendingTasks: string) => void;
  getActivityLogData: (e: ActivityLogInfo[]) => void;
  waterReadingInst?: string;
  status?: string;
};
let activityLog: ActivityLogInfo[] = [];

export default function WaterReadingModal(props: Props) {
  const {
    onModalClose,
    userFirebaseId,
    loadChecklistData,
    waterReadingData,
    waterReadingInst,
    status,
    getActivityLogData,
  } = props;
  const { register } = useForm();
  const { transactionId }: any = useParams();
  const [updateCheckList] = useUpdateChecklistMutation();
  const [fileName, setFileName] = React.useState<string>('');
  const [saving, updatesaving] = React.useState<boolean>(false);

  const [waterReadDetails, setWaterReadDetails] = React.useState({
    finalReadingAvailNow: 'no',
    FinalReadingRequested: 'no',
    dateForFinalReading: moment().format('YYYY-MM-DD'),
    image: TransactionlogoUrl,
  });

  React.useEffect(() => {
    if (waterReadingData) {
      activityLog = [];
      const {
        finalReadingAvailNow = 'no',
        FinalReadingRequested = 'no',
        dateForFinalReading = moment().format('YYYY-MM-DD'),
        image = '',
        fileName = '',
      } = waterReadingData;
      setWaterReadDetails({
        finalReadingAvailNow: finalReadingAvailNow,
        FinalReadingRequested: FinalReadingRequested,
        dateForFinalReading: moment(dateForFinalReading).format('YYYY-MM-DD'),
        image: image ? image : TransactionlogoUrl,
      });
      setFileName(fileName);
    }
  }, [waterReadingData]);

  const onWaterReadImageChange = (event: any) => {
    event.preventDefault();
    if (event.target.files && event.target.files[0]) {
      setFileName(event.target.files[0].name);
      const reader = new FileReader();
      reader.onload = (e: any) => {
        setWaterReadDetails({ ...waterReadDetails, image: e.target.result });
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };
  const getActivityLog = () => {
    if (status !== 'COMPLETED') {
      activityLog.push({
        transactionId: transactionId,
        firebaseId: userFirebaseId,
        item: `Response`,
        description: 'for Water Reading task has been submitted by ',
      });
      return activityLog;
    } else {
      if (
        waterReadingData.finalReadingAvailNow !==
        waterReadDetails.finalReadingAvailNow
      ) {
        activityLog.push({
          transactionId: transactionId,
          firebaseId: userFirebaseId,
          item: `Response`,
          description: 'for Water Reading task has been updated by ',
        });
      } else if (
        waterReadingData.FinalReadingRequested !==
        waterReadDetails.FinalReadingRequested
      ) {
        activityLog.push({
          transactionId: transactionId,
          firebaseId: userFirebaseId,
          item: `Response`,
          description: 'for Water Reading task has been updated by ',
        });
      } else if (
        waterReadingData.dateForFinalReading !==
        waterReadDetails.dateForFinalReading
      ) {
        activityLog.push({
          transactionId: transactionId,
          firebaseId: userFirebaseId,
          item: `Response`,
          description: 'for Water Reading task has been updated by ',
        });
      }
      return activityLog;
    }
  };

  const submitChecklistData = () => {
    updatesaving(true);
    const checklistVariables = {
      transactionId: transactionId,
      status: 'COMPLETED',
      userType:
        waterReadingData && waterReadingData.userType
          ? waterReadingData.userType
          : '',
      completedAt: moment().format('YYYY-MM-DD'),
      firebaseId: userFirebaseId,
      assignmentChecklistKey: 'waterReading',
      isFinalReadingAvailNow: waterReadDetails.finalReadingAvailNow,
      isFinalReadingRequested: waterReadDetails.FinalReadingRequested,
      dateForFinalReading: waterReadDetails.dateForFinalReading,
      activityLog: getActivityLog(),
      readingDocuments: [
        {
          name: fileName,
          src:
            waterReadDetails.image === TransactionlogoUrl
              ? ''
              : waterReadDetails.image,
          uploadedDate: moment().format('YYYY-MM-DD'),
        },
      ],
    };
    updateCheckList({
      variables: checklistVariables,
    }).then((res: any) => {
      if (res.data.updateTransactionChecklist.success) {
        const {
          updateTransactionChecklist: { transaction },
        } = res.data;
        const { assignmentChecklist, activityLog, pendingTasks } = transaction;
        loadChecklistData(assignmentChecklist, pendingTasks);
        getActivityLogData(activityLog);
        updatesaving(false);
        setTimeout(onModalClose, 100);
      }
    });
  };
  const deleteIamge = (e: any) => {
    setWaterReadDetails({ ...waterReadDetails, image: TransactionlogoUrl });
    setFileName('');
  };

  return (
    <Dialog title="Water Reading" onClose={onModalClose}>
      <ModalContainer>
        <ChecklistText>{waterReadingInst}.</ChecklistText>
        <ChecklistInfoBox>
          <ChecklistPrimaryText>
            Is the final water reading available now?
          </ChecklistPrimaryText>
          <ChecklistInfoCard>
            <RadioItem>
              <RadioButton
                label="Yes"
                name="waterreading"
                checked={waterReadDetails.finalReadingAvailNow === 'yes'}
                value={'yes'}
                onChange={() => {
                  setWaterReadDetails({
                    ...waterReadDetails,
                    finalReadingAvailNow: 'yes',
                  });
                }}
                register={register({})}
              />
            </RadioItem>
            <RadioItem>
              <RadioButton
                label="No"
                name="waterreading"
                checked={waterReadDetails.finalReadingAvailNow === 'no'}
                value={'no'}
                onChange={() => {
                  setWaterReadDetails({
                    ...waterReadDetails,
                    finalReadingAvailNow: 'no',
                  });
                }}
                register={register({})}
              />
            </RadioItem>
          </ChecklistInfoCard>
          {waterReadDetails.finalReadingAvailNow === 'yes' && (
            <ModalInfocard>
              <ChecklistInfoCard>
                <Uploader
                  label="Image of final water reading"
                  onChange={e => onWaterReadImageChange(e)}
                  fileName={fileName}
                  chooseText="Browse file"
                  profileImage={waterReadDetails.image}
                  borderRadius="8px"
                  onImageDelete={e => deleteIamge(e)}
                />
              </ChecklistInfoCard>
            </ModalInfocard>
          )}
          {waterReadDetails.finalReadingAvailNow === 'no' && (
            <ModalInfocard>
              <ChecklistPrimaryText>
                Has the final water reading been requested?
              </ChecklistPrimaryText>
              <ChecklistInfoCard>
                <RadioItem>
                  <RadioButton
                    label="Yes"
                    name="finalwaterreading"
                    checked={waterReadDetails.FinalReadingRequested === 'yes'}
                    value={'yes'}
                    onChange={() => {
                      setWaterReadDetails({
                        ...waterReadDetails,
                        FinalReadingRequested: 'yes',
                      });
                    }}
                    register={register({})}
                  />
                </RadioItem>
                <RadioItem>
                  <RadioButton
                    label="No"
                    name="finalwaterreading"
                    checked={waterReadDetails.FinalReadingRequested === 'no'}
                    value={'no'}
                    onChange={() => {
                      setWaterReadDetails({
                        ...waterReadDetails,
                        FinalReadingRequested: 'no',
                      });
                    }}
                    register={register({})}
                  />
                </RadioItem>
              </ChecklistInfoCard>
              {waterReadDetails.FinalReadingRequested === 'yes' && (
                <ChecklistInfoCard>
                  <ModalInput>
                    <Input
                      type="date"
                      label=" Date for final water reading"
                      name="closingDate"
                      value={waterReadDetails.dateForFinalReading}
                      onChange={e => {
                        setWaterReadDetails({
                          ...waterReadDetails,
                          dateForFinalReading: e.target.value,
                        });
                      }}
                      register={register({})}
                      min={moment().format('YYYY-MM-DD')}
                    />
                  </ModalInput>
                </ChecklistInfoCard>
              )}
            </ModalInfocard>
          )}
        </ChecklistInfoBox>
      </ModalContainer>
      <Footer>
        {saving && (
          <SavingIndicator>
            <FontAwesomeIcon
              color={primaryColor}
              icon={faCircleNotch}
              size="lg"
              spin
            />
          </SavingIndicator>
        )}
        <CancelButton>
          <Button variant="text" size="medium" onClick={onModalClose}>
            Cancel
          </Button>
        </CancelButton>
        <ChecklistButtonContainer disabled={saving}>
          <Button
            variant="primary"
            size="medium"
            width="100%"
            type="submit"
            onClick={submitChecklistData}>
            Submit Task
          </Button>
        </ChecklistButtonContainer>
      </Footer>
    </Dialog>
  );
}
